import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectActiveEntitiesArray } from '../../services/entities/selectors';
import { selectCurrentEntityId } from '../../services/currentEntityId/selectors';
import { selectEntityTypeFirstDepth } from '../../services/entityTypes/selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
const selectEntityTypeId = (state, props) => props.entityTypeId;
const selectIgnoreCurrentEntityId = (state, props) =>
    props.ignoreCurrentEntityId;

const selectFilteredData = createDeepEqualSelector(
    [
        selectActiveEntitiesArray,
        selectCurrentEntityId,
        selectEntityTypeId,
        selectEntityTypeFirstDepth,
        selectIgnoreCurrentEntityId
    ],
    (
        activeEntitiesArray,
        currentEntityIdState,
        entityTypeIdState,
        entityTypeFirstDepthState,
        ignoreCurrentEntityIdState
    ) =>
        activeEntitiesArray.filter(value => {
            const { entityTypeId, path, id } = value;
            // Filter out entities with a different entityType
            if (entityTypeIdState && entityTypeIdState !== entityTypeId) {
                return false;
            }
            if (!entityTypeFirstDepthState && currentEntityIdState && !path) {
                return false;
            }
            if (
                !ignoreCurrentEntityIdState &&
                (currentEntityIdState &&
                    !(
                        `${path}/`.includes(`/${currentEntityIdState}/`) ||
                        id === currentEntityIdState
                    ))
            ) {
                return false;
            }
            return true;
        })
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredData => orderBy(filteredData, 'pathNames')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(({ id, pathNames }) => ({
            key: id,
            text: pathNames,
            value: id
        }))
);

export { selectOptions };
